<!-- 支付宝账号选择 -->
<template>
  <div class="account-select-popup">
    <van-overlay :show="show" :lock-scroll="false" class="my-overlay">
      <!-- @click="close" -->
      <div class="wrapper" @click.stop>
        <div class="titile">请选择常用的支付宝账号</div>
        <div class="content">
          <div class="card">
            <div
              v-for="item in zfbAccount"
              :key="item.account"
              :class="{
                accout: true,
                selected: currentAccount == item.openid,
              }"
              @click.stop="currentAccount = item.openid"
            >
              {{ item.account }}
              <img
                v-if="item.openid === currentAccount"
                class="icon"
                src="../../../../assets/imgs/yunnanPostalWhiteList/gou.png"
                alt=""
              />
            </div>
            <p class="tip" v-if="isError">
              不存在实名认证的账号，请修改绑定的支付宝账号！
            </p>
          </div>
        </div>
        <div class="btn-row">
          <van-button round type="success" color="#000000" @click="close"
            >取消</van-button
          >
          <van-button
            round
            type="success"
            color="#000000"
            @click="submit"
            :loading="loading"
            >确认</van-button
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
import {
  selectAccount,
  receive,
} from '@/api/yunnanPsbc'
export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
      zfbAccount: [],
      currentAccount: undefined,
      isError: false,
      loading: false,
    }
  },
  methods: {
    open(phone) {
      this.setShow(true)
      selectAccount({
        phone: phone
      }).then((res) => {
        this.zfbAccount = res.data
        if (res.data.length === 0) {
          this.isError = true
        }
        if (res.data.length === 1) {
          this.currentAccount = res.data[0].openid
        }
      })
    },
    close() {
      this.setShow(false)
      this.zfbAccount = []
      this.currentAccount = undefined
      this.isError = false
      this.$emit('account-select-popup-close')
    },
    setShow(val) {
      this.show = val
    },
    submit() {
      if (!this.currentAccount) {
        return Toast('请选择常用的支付宝账号！')
      }
      this.loading = true
      this.$emit('receive', this.currentAccount, () => {
        this.loading = false
        this.close()
      })

    },
  },
}
</script>
<style lang="less" scoped>
.account-select-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    padding: 20px 15px 30px 25px;
    width: 333px;
    height: 430px;
    box-sizing: border-box;
    background: url("../../../../assets/imgs/yunnanPostalWhiteList/dialog-bg1.png")
      no-repeat;
    background-size: 100% auto;
    text-align: center;
    font-size: 20px;
    .titile {
      font-weight: bold;
      font-size: 21px;
      color: #ffffff;
      line-height: 30px;
    }
    .content {
      margin: 40px auto 20px auto;
      width: 100%;
      height: 200px;
      overflow: auto;
    }
    .card {
      .accout {
        position: relative;
        margin: 10px auto 0 auto;
        width: 270px;
        height: 53px;
        line-height: 53px;
        background: #eeffd9;
        border-radius: 27px;
        border: 1px solid #30894a;
        font-size: 14px;
        color: #000000;
        text-align: center;
      }
      .selected {
        background: #30894a;
        border: 1px solid #30894a;
        color: #fffefe;
      }
      .icon {
        position: absolute;
        right: 20px;
        top: 18px;
        width: 18px;
      }
    }
    .tip {
      margin: 20px;
      font-size: 14px;
      color: #000000;
    }
    .btn-row {
      button {
        width: 130px;
        height: 47px;
        font-weight: 600;
        font-size: 16px;
        &:first-child {
          margin-right: 11px;
        }
      }
    }
  }
}
</style>
